import React from "react";
import CarModel from "../components/cars/CarModel";

const Cars = () => {
  return <CarModel />;
};

export default Cars;
